import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import FlightPtbrsEditModal from './FlightPtbrsEditModal';
import getLocale from '../../../i18n/getLocale';

class FlightPtbrsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      modal_props: false,
      flight_ptbrs: [],
      data_flight_ptbr: [],
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.flight_ptbrs)) {
      this.setState({flight_ptbrs: newProps.flight_ptbrs, modal_props: newProps.modal_props});
    }
  }

  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.name,
      reason: this.state.reason,
      code: this.state.code,
      type: this.state.type,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/referencias/ptbr/justificativa/atraso', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshTable(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-primary btn-sm" value={cell} onClick={this.showModal}>
          <i className="fa fa-fw fa-pencil"></i>
        </button>
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var fight_ptbr_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.deletarJustificativa);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/referencias/ptbr/justificativa/atraso/' + fight_ptbr_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(fight_ptbr_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(fight_ptbr_id) {
    var data = this.state.flight_ptbrs;
    data.map(function(dado, index){
      if (dado.id == fight_ptbr_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }


  showModal(event) {
    var self = this;
    var fight_ptbr_id = event.currentTarget.value;

    var data = self.state.flight_ptbrs;
    data.map(function(dado, index){
      if (dado.id == fight_ptbr_id) {
        self.setState({
          data_flight_ptbr: dado,
          modal_props: true,
        });
      }
    });
  }

  closeModal(responseJson) {
    this.setState({
      modal_props: false,
      data_flight_ptbr: {},
    });
  }



  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formulario.Nome}</label>
          <input type="text" name="name" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formulario.placeholder.Nome} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formulario.Motivo}:</label>
          <input type="text" name="reason" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formulario.placeholder.Motivo} value={this.state.reason} onChange={this.handleChange.bind(this, 'reason')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formulario.Codigo}</label>
          <input type="text" name="code" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formulario.placeholder.Codigo} value={this.state.code} onChange={this.handleChange.bind(this, 'code')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formulario.Tipo}:</label>
          <Select
            className="form-field-name"
            name="type"
            value={this.state.type}
            searchable={true}
            placeholder={this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formulario.placeholder.SelecioneTipo}
            onChange={this.handleSelectChange.bind(this, 'type')}
            options={[
              {value: "departure", label: this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formulario.opcoesTipo.Decolagem},
              {value: "flight", label: this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formulario.opcoesTipo.TempoDeVoo},
            ]}
          />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formulario.botaoAdicionarJustificativaDeAtrasoPTBR}</button>
      </div>
    </div>
  </form>
  <hr/>
  <BootstrapTable data={this.state.flight_ptbrs} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.tabela.semJustificativasDeAtrasoPTBR}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.tabela.ID}</TableHeaderColumn>
    <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.tabela.Nome}</TableHeaderColumn>
    <TableHeaderColumn dataField="reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.tabela.Motivo}</TableHeaderColumn>
    <TableHeaderColumn dataField="code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.tabela.Código}</TableHeaderColumn>
    <TableHeaderColumn dataField="type_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.tabela.Tipo}</TableHeaderColumn>
    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.tabela.Acoes}</TableHeaderColumn>

  </BootstrapTable>
  <FlightPtbrsEditModal handleAlert={self.props.handleAlert} closeModal={self.closeModal} modal_props={self.state.modal_props} data_flight_ptbr={self.state.data_flight_ptbr} refreshTable={self.props.refreshTable} />
</div>
    );
  }
}

export default FlightPtbrsTab;



// WEBPACK FOOTER //
// ./src/Components/Ptbr/Elements/FlightPtbrsTab.js